const PREFIX = 'exterior';

export const SPARTAN_PRODUCT_EXTERIOR_TRACKING = {
  section: PREFIX,
  header: `${PREFIX}-header`,
  eyebrow: `${PREFIX}-eyebrow`,
  title: `${PREFIX}-title`,
  description: `${PREFIX}-description`,
  threesixtyTrack: `${PREFIX}-threesixty-track`,
  threesixtyStage: `${PREFIX}-threesixty-stage`,
  threesixtyPreview: `${PREFIX}-threesixty-preview`,
  threesixtyPreviewPoster: `${PREFIX}-threesixty-preview-poster`,
  threesixtyPreviewStretch: `${PREFIX}-threesixty-preview-stretch`,
  threesixty: `${PREFIX}-threesixty`,
  threesixtyModal: `${PREFIX}-threesixty-modal`,
  threesixtyPanel: `${PREFIX}-threesixty-panel`,
  threesixtyBackground: `${PREFIX}-threesixty-background`,
  threesixtyBackgroundTop: `${PREFIX}-threesixty-background-top`,
  threesixtyBackgroundBottom: `${PREFIX}-threesixty-background-bottom`,
  threesixtyClose: `${PREFIX}-threesixty-close`,
  threesixtyViewer: `${PREFIX}-threesixty-viewer`,
  threesixtyViewerCanvas: `${PREFIX}-threesixty-viewer-canvas`,
  threesixtyDragCursor: `${PREFIX}-threesixty-drag-cursor`,
  threesixtyGuide: `${PREFIX}-threesixty-guide`,
  threesixtyGuideWrapper: `${PREFIX}-threesixty-guide-wrapper`,
  threesixtyControlsHost: `${PREFIX}-threesixty-controls-host`,
  threesixtyControls: `${PREFIX}-threesixty-controls`,
  threesixtyPresetsSlot: `${PREFIX}-threesixty-presets-slot`,
  threesixtyPresets: `${PREFIX}-threesixty-presets`,
  threesixtyPreset: (index: number) =>
    `${PREFIX}-threesixty-preset-${index + 1}`,
  threesixtyPresetImage: (index: number) =>
    `${PREFIX}-threesixty-preset-${index + 1}-image`,
  threesixtyLoadingGuide: `${PREFIX}-threesixty-loading-guide`,
  threesixtyLoading: `${PREFIX}-threesixty-loading`,
  threesixtyLoadError: `${PREFIX}-threesixty-load-error`,
  threesixtyRetry: `${PREFIX}-threesixty-retry`,
  threesixtyErrorBack: `${PREFIX}-threesixty-error-back`,
  featureList: `${PREFIX}-feature-list`,
  feature: (index: number) => `${PREFIX}-feature-${index + 1}`,
  featureTitle: (index: number) => `${PREFIX}-feature-${index + 1}-title`,
  featureDescription: (index: number) =>
    `${PREFIX}-feature-${index + 1}-description`,
  featureMedia: (index: number) => `${PREFIX}-feature-${index + 1}-media`,
  featurePlay: (index: number) => `${PREFIX}-feature-${index + 1}-play`,
  featurePrev: `${PREFIX}-feature-prev`,
  featureNext: `${PREFIX}-feature-next`,
  featureThumbnailList: `${PREFIX}-feature-thumbnail-list`,
  featureThumbnail: (index: number) =>
    `${PREFIX}-feature-thumbnail-${index + 1}`,
  featureThumbnailPlayback: (index: number) =>
    `${PREFIX}-feature-thumbnail-${index + 1}-playback`,
  featureThumbnailImage: (index: number) =>
    `${PREFIX}-feature-thumbnail-${index + 1}-image`,
} as const;

export const SPARTAN_PRODUCT_EXTERIOR_DATA_GA = {
  section: PREFIX,
  preset: 'preset',
  drag: 'lcv-product-drag',
} as const;
